import {
  BuildNumber
} from "../chunk-YW3SPCXZ.js";
import "../chunk-X3MX6SC5.js";

// lib/errors/errorPage.tsx
import styled from "@emotion/styled";
import {
  PestControl as BugIcon,
  RefreshOutlined as RefreshIcon
} from "@mui/icons-material";
import { Button } from "@mui/material";
import { useNavigate, useRouteError } from "react-router-dom";
import { jsx, jsxs } from "react/jsx-runtime";
var Page = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 2em;
`;
var ErrorPage = () => {
  const error = useRouteError();
  const navigate = useNavigate();
  return /* @__PURE__ */ jsxs(Page, { children: [
    /* @__PURE__ */ jsx(BugIcon, { fontSize: "large" }),
    /* @__PURE__ */ jsx("h1", { children: "Dev Burr\xE3o Detected" }),
    /* @__PURE__ */ jsx("p", { children: "Ihhhhh! Bugou! M\xF3 Dev Burr\xE3o!" }),
    /* @__PURE__ */ jsx("p", { children: /* @__PURE__ */ jsx("i", { children: error.statusText ?? error.message }) }),
    /* @__PURE__ */ jsx(BuildNumber, {}),
    process.env.PUBLIC_PATH !== void 0 && /* @__PURE__ */ jsxs(
      Button,
      {
        sx: { marginTop: 8, gap: 1 },
        onClick: () => {
          navigate(process?.env?.PUBLIC_PATH?.toString() ?? "/");
        },
        children: [
          /* @__PURE__ */ jsx(RefreshIcon, {}),
          " Reload"
        ]
      }
    )
  ] });
};

// lib/errors/notImpl.ts
var ThrowNotImplemented = (msg) => () => {
  throw new Error(msg ?? "Function not implemented");
};
export {
  ErrorPage,
  ThrowNotImplemented
};
